import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReferrerLinkedProfilesLoader from "./referrer-loader/referrer-linked-profiles-loader.vue";
import { mapActions, mapGetters } from "vuex";
import { LOAD_REFERRER_LINKED_PROFILES } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import { LABEL_LINKED_PROFILES } from "@Broker/@Modules/clients/referrers/store/referrer-getters";
import NoResults from "@Shared/components/general/no-results.vue";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerLinkedProfiles",
  components: {
    ReferrerLinkedProfilesLoader,
    NoResults,
    CollapsibleCard
  },
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    },
    profiles: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [LABEL_LINKED_PROFILES])), {}, {
    isEmpty() {
      return isEmpty(this.profiles);
    }
  }),
  activated() {
    this.loadLinkedProfiles();
  },
  mounted() {
    this.loadLinkedProfiles();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRER_LINKED_PROFILES])), {}, {
    clientProfileLink(clientProfileId, boardId) {
      return {
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      };
    },
    async loadLinkedProfiles() {
      this.loading = true;
      await this.LOAD_REFERRER_LINKED_PROFILES({
        referrerId: this.referrerId
      });
      this.loading = false;
    }
  })
});